<template>
    <div class="input-wrap input--job">
        <input type="text" placeholder="Search..." :value="value" @input="onInput" >
        <i v-html="SearchIcon"></i>
    </div>
</template>

<script>
    import SearchIcon from '../../assets/icons/search.svg'
    export default {
        name: 'jobs-input',
        props: {
            value: String
        },
        data() {
            return {
                SearchIcon
            }
        },
        methods: {
            onInput(e) {
                this.$emit('input', e)
            }
        }
    }
</script>

<style scoped lang="scss" type="text/scss">
    @import "../../assets/scss/globals";

    .input-wrap {
        position: relative;
        display: inline-block;

        input {
            // input reset start
            width: 100%;
            background: none;
            border: 2px solid $text-weak;
            border-radius: 0;
            outline: 0;
            font-size: 1em;
            box-shadow: none;
            font-family: "Inter UI", sans-serif;
            // input reset end
        }
    }

    .input--job {
        font-size: 14px;

        input {
            height: 37px;
            line-height: 37px;
            border-radius: 26px;
            border: 2px solid $text-weak;
            padding: 0 20px 0 40px;
            color: $text-weak;
            font-family: "Inter UI", sans-serif;
            @media(max-width: $compact){
                text-align: center;
            }
            &:focus{
                border-color: $text-blue;
             }
        }

        i {
            position: absolute;
            line-height: 0;
            top: 50%;
            left: 15px;
            transform: translateY(-50%);
            font-size: 16px;
            color: black;
        }
    }
</style>

<style lang="scss">
    .input--job svg {
        width: 1em;
        height: 1em;
        fill: currentColor;
    }
</style>



// WEBPACK FOOTER //
// src/components/jobs/JobsInput.vue